//
// social-index/fetch-index.js
//

import * as nayjax from 'nayjax';
let html_decode = require('../../../core/js/helpers/html-decode');
let helpers = require('./helpers');
let parse = require('./csv-parse');


// fetch_index(name) -> promise
// ----------------------------
// - errors: ajax error
//           nonexistent
//

function fetch_index(index_name) {
  let url = helpers.find_index_prop(index_name, 'url');
  if (!url) {
    return Promise.reject(Error('nonexistent'));
  }

  url += '?rev=' + Date.now();

  return nayjax.get(url)
    .then((text) => html_decode(text))
    .then((text) => parse(text, true))
    .catch((err) => { throw Error('ajax error'); });
}

export default fetch_index;
